import type { SiteFragment } from "@commerce-frontend/types";
import type { Organization, PostalAddress, WithContext } from "schema-dts";
import type { StoreConfig } from "../store-config/context/types";

type Props = {
	data?: SiteFragment | null;
	storeConfig: StoreConfig;
};

export const OrganizationJsonLd = ({ data, storeConfig }: Props) => {
	if (!data) return null;

	const address: PostalAddress = {
		"@type": "PostalAddress",
		streetAddress: data.organizationAddress?.street ?? undefined,
		addressLocality: data.organizationAddress?.locality ?? undefined,
		postalCode: data.organizationAddress?.postalCode ?? undefined,
		addressCountry: data.organizationAddress?.country ?? undefined,
	};

	const isAddressFilled = Object.values(address).every((value) => value !== undefined);

	const jsonLdOrganization: WithContext<Organization> = {
		"@context": "https://schema.org",
		"@type": "Organization",
		"@id": `${storeConfig.metadata.productionUrl}/#Organization`,
		name: storeConfig.metadata.siteName ?? undefined,
		url: storeConfig.metadata.productionUrl ?? undefined,
		logo: data.logo.filename ?? undefined,
		sameAs: [
			data.facebook?.url ?? "",
			data.instagram?.url ?? "",
			"https://twitter.com/zeemantextiel",
			"https://www.zeemanvacatures.nl/",
			"https://www.trustedshops.nl/verkopersbeoordeling/info_X11E3F3CCB0ED1ED2DBEDB041D892E4B5.html",
		].filter((d) => d),
		...(isAddressFilled && { address }),
	};

	return (
		<script
			type="application/ld+json"
			dangerouslySetInnerHTML={{
				__html: JSON.stringify(jsonLdOrganization),
			}}
		/>
	);
};
